import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOnline } from "common/hooks";
import { getFarmGroups } from "containers/FarmHome/_actions";

export function useFarm(farmId) {
    const farm = useSelector(state => {
        const offlineFarm = state.offlineFarms.find(f => f.id === farmId) || {};
        return offlineFarm.farm;
    })
    return farm;
}

export function useAnalysis(farmId, budgetId) {
    const analysis = useSelector(state => {
        const offlineFarm = state.offlineFarms.find(f => f.id === farmId) || {};
        const farm = offlineFarm.farm || {};
        const offlineBudget = (farm.offlineBudgets || []).find(b => b.id === budgetId) || {};
        return offlineBudget.budget;
    })
    return analysis;
}

export function useFarmGroups(farmId) {
    const dispatch = useDispatch();
    const online = useOnline();
    const [farmGroups, setFarmGroups] = useState([]);

    useEffect(() => {
        let isMounted = true;
        if (online && farmId) {
            dispatch(getFarmGroups(farmId))
                .then((response) => isMounted && setFarmGroups(response));
        }
        return () => isMounted = false;
    }, [farmId, online, dispatch]);

    return farmGroups;
}
